import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { CustomValidatorService } from 'src/app/shared/services/custom-validator.service';
import { InspectionOfficer } from '../../models/inspectionOfficer';
import { InspectionStorageService } from '../../services/inspection-storage.service';

@Component({
  selector: 'app-officer',
  templateUrl: './officer.component.html',
  styleUrls: ['./officer.component.scss'],
})
export class OfficerComponent implements OnInit {
  officerForm: FormGroup;
  inspectionOfficer: InspectionOfficer;
  inspectionOfficers: InspectionOfficer[]=[];
  contactNumberAlreadyExist = false;

  constructor(
    private fb: FormBuilder,
    private notification: NzNotificationService,
    private customValidatorService: CustomValidatorService,
    private inspectionStorageService: InspectionStorageService
  ) {}

  ngOnInit(): void {
    this.officerForm = this.fb.group({
      name: [
        null,
        [Validators.required],
        Validators.composeAsync([
          this.customValidatorService.noWhitespaceValidator(),
        ]),
      ],
      email: [null, [Validators.required, Validators.email]],
      phone: [null, [
        Validators.required,
        Validators.pattern(/^(?:\01)?(?:\d{11})$/),
      ]],
    });
  }

  submitForm(): void {
    this.inspectionOfficer = this.officerForm.value;
    this.inspectionStorageService.saveInspectionOfficer(this.inspectionOfficer).subscribe({
      next:(response) => {
        this.notification.success(
          'Success!',
          'Officer Information saved successfully'
        );
      },
      error: (error) => this.notification.error('Failed', error),
    });
   }
  resetForm(): void {
    this.officerForm.reset();
    for (const key of Object.keys(this.officerForm.controls)) {
      this.officerForm.controls[key].markAsPristine();
      this.officerForm.controls[key].updateValueAndValidity();
    }
  }

  //#region check unique contact number
  checkContactNumberIfExist(phone: any): void {
    this.contactNumberAlreadyExist = false;
    setTimeout(() => {
      if (phone.value.length > 10) {
        this.inspectionStorageService
          .checkContactNumberExist(phone.value)
          .subscribe({
            next: (res) => {
              if (res.success == true) {
                this.contactNumberAlreadyExist = false;
              } else {
                this.contactNumberAlreadyExist = true;
                this.officerForm.controls.phone.setErrors({
                  incorrect: true,
                });
              }
            },
          });
      }
    }, 500);
  }
  //#endregion
}
